export default __webpack_public_path__ + "images/0x578ee1ca3a8e1b54554da1bf7c583506c4cd11c6.png";